import React from 'react';
import { createRoot } from 'react-dom/client';
import './config';
import './icon-library';
import Root from './Root';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<Root />);
